import { useGetKnowledgeItem } from "@/lib/api/knowledge";
import { KnowledgeEditor, useKnowledgeEditor } from "@/section/knowledge/components/KnowledgeEditor";
import { Loader } from "@/components/ui/loader";

interface ContractLanguageViewProps {
  knowledgeItemId: string;
  title: string;
}

export function ContractLanguageView({ knowledgeItemId, title }: ContractLanguageViewProps) {
  const knowledgeItemResult = useGetKnowledgeItem(knowledgeItemId);
  const knowledgeItem = knowledgeItemResult?.data?.data;
  
  const { editor, error, handleFileUpload, fileInputRef } = useKnowledgeEditor({
    mode: 'view',
    existingData: knowledgeItem?.content,
    taskId: knowledgeItemId,
  });

  if (knowledgeItemResult.isLoading) {
    return (
      <div className="flex items-center justify-center h-full">
        <Loader className="w-8 h-8" />
      </div>
    );
  }

  if (knowledgeItemResult.isError || !knowledgeItem) {
    return (
      <div className="flex items-center justify-center h-full">
        <p className="text-destructive">Failed to load {title}</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4 h-full overflow-auto p-4">
      <KnowledgeEditor
        mode="view"
        existingData={knowledgeItem.content}
        taskId={knowledgeItemId}
        editor={editor}
        handleFileUpload={handleFileUpload}
        fileInputRef={fileInputRef}
        error={error}
      />
    </div>
  );
}
